import React from 'react';

// FIXME match filename with default export
import FixedFiltersProvider from './context/FixedFiltersContext';
import FixedFilters from './FixedFilters';

// TODO type FiltersWithContext props
export type FiltersWithContextProps = any;

const FiltersWithContext: React.FC<FiltersWithContextProps> = ({
  initialFilters,
  hideLockButton,
  locked,
  onFiltersChange,
  filterName,
  readOnly,
}) => (
  <FixedFiltersProvider
    initialFilters={initialFilters}
    locked={locked}
    onFiltersChange={onFiltersChange}
    filterName={filterName}
    readOnly={readOnly}
    hideLockButton={hideLockButton}
  >
    <FixedFilters locked={locked} />
  </FixedFiltersProvider>
);

export default FiltersWithContext;
